import React from "react";
import clsx from 'clsx';
import "./Textarea.scss";
function Textarea(props) {
  return (
    <>
      <textarea
        className={clsx(props.className,"Textarea")}
        placeholder={props.placeholder}
        type={props.type}
        id={props.id}
        onChange={props.onChange}
        value={props.value}
        maxLength={props.maxLength ? props.maxLength : 250}
      />
    </>
  );
}

export default Textarea;
